import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { IS_FIREFOX } from '../helpers/BrowserHelpers';

var FirefoxSafeIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FirefoxSafeIcon, _React$Component);

  function FirefoxSafeIcon(props) {
    var _this;

    _classCallCheck(this, FirefoxSafeIcon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FirefoxSafeIcon).call(this, props));

    if (IS_FIREFOX) {
      _this.staticMarkupUrl = "url(\"data:image/svg+xml,".concat(encodeURIComponent(renderToStaticMarkup(props.children)), "\")");
    }

    return _this;
  }

  _createClass(FirefoxSafeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className"]);

      var size = children.props.size || 16;
      return IS_FIREFOX ? React.createElement("span", Object.assign({
        style: {
          mask: this.staticMarkupUrl,
          height: size,
          width: size,
          display: 'inline-flex',
          alignItems: 'center'
        },
        className: className
      }, otherProps)) : React.cloneElement(React.Children.only(children), otherProps);
    }
  }]);

  return FirefoxSafeIcon;
}(React.Component);

export { FirefoxSafeIcon as default };